<template>
  <Allow
      title="Рассылка сообщений, управление и виджет в группе отключены"
      :content="content"
      @action="action"
  ></Allow>
</template>

<script>
import Allow from '@/components/Allow'
import {tokenGet} from '@/services/vkApi'

export default {
  name: 'AllowToken',
  components: {Allow},
  data () {
    return {
      content: '<br/>- С помощью рассылки вы сможете автоматически оповещать своих пользователей об выставлении счетов, ' +
          'изменениях правил закупки, наличии товара или открытии новых закупок.<br/><br/>' +
          '- Управление позволит мгновенно получать и обрабатывать комментарии клиентов из любой закупки вашей группы. <br/><br/>' +
          '- Виджет позволит вам вывести в заголовок вашей группы активные закупки, а также информацию о наборе и стопе по ним.'
    }
  },
  methods: {
    action: tokenGet
  }
}
</script>

<style scoped>

</style>